import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import Group from '@spa/shared/components/Filters/Group';

const GroupItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

const filters = ['has-trusted-landlord', 'has-checked-place'];

const Verification = ({ fields, onChangeEventHandler }) => {
  const { t } = useTranslation('translations');

  return (
    <Group title={t('filters.sections.verification')}>
      <GroupItemsContainer>
        {filters.map(filter => (
          <CheckboxFilter
            key={filter}
            name={filter}
            value={true}
            onChange={onChangeEventHandler}
            selected={fields[filter]}
            label={t(`filters.labels.${filter}`)}
          />
        ))}
      </GroupItemsContainer>
    </Group>
  );
};

Verification.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired
};

export default Verification;
